export default __webpack_public_path__ + "static/media/ground.514a776e.png";